/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ShoppingExperienceInputDto } from '../model/shoppingExperienceInputDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EngineRgpdService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Experience d&#39;achat
     * Récupère les status des accord RGPD de l&#39;experience d&#39;achat dans le tunel de vente par rapport aux requestid
     * @param requestIds requestIds
     * @param tenantId tenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getShoppingExperienceUsingPOST(requestIds: Array<string>, tenantId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getShoppingExperienceUsingPOST(requestIds: Array<string>, tenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getShoppingExperienceUsingPOST(requestIds: Array<string>, tenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getShoppingExperienceUsingPOST(requestIds: Array<string>, tenantId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (requestIds === null || requestIds === undefined) {
            throw new Error('Required parameter requestIds was null or undefined when calling getShoppingExperienceUsingPOST.');
        }

        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling getShoppingExperienceUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/v1/rgpd/shoppingExperience/${encodeURIComponent(String(tenantId))}`,
            requestIds,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Experience d&#39;achat
     * Ajoute la valeur de l&#39;accord RGPD de l&#39;experience d&#39;achat dans le tunel de vente
     * @param experienceInputDto experienceInputDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public shoppingExperienceUsingPOST(experienceInputDto: ShoppingExperienceInputDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public shoppingExperienceUsingPOST(experienceInputDto: ShoppingExperienceInputDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public shoppingExperienceUsingPOST(experienceInputDto: ShoppingExperienceInputDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public shoppingExperienceUsingPOST(experienceInputDto: ShoppingExperienceInputDto, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (experienceInputDto === null || experienceInputDto === undefined) {
            throw new Error('Required parameter experienceInputDto was null or undefined when calling shoppingExperienceUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/public/v1/rgpd/shoppingExperience`,
            experienceInputDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
